












































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import getClientId from '@/utils/getClientId'
import { updateConnection } from '@/utils/api/connection'
import { ConnectionModel, FormRule, NameCallBack } from './types'
import { MqttClient } from 'mqtt'
import { Getter } from 'vuex-class'

@Component
export default class ConnectionInfo extends Vue {
  @Prop({ required: true }) public connection!: ConnectionModel
  @Prop({ required: true }) public btnLoading!: boolean
  @Prop({ required: true }) public client!: MqttClient | {}
  @Prop({ required: true }) public titleName!: string

  @Getter('allConnections') private allConnections!: ConnectionModel[] | []

  private oldName = ''

  @Watch('titleName', { immediate: true, deep: true })
  private handleNameChange(titleName: string) {
    this.oldName = titleName
  }

  get rules() {
    return {
      name: [
        { required: true, message: this.$t('common.inputRequired') },
        { validator: this.validateName, trigger: 'blur' },
      ],
      clientId: [{ required: true, message: this.$t('common.inputRequired') }],
    }
  }

  get vueForm(): VueForm {
    return this.$refs.form as VueForm
  }

  private async validateName(rule: FormRule, name: string, callBack: NameCallBack['callBack']) {
    for (const oneConnection of this.allConnections) {
      if (name !== this.oldName && oneConnection.name === name) {
        callBack(`${this.$t('connections.duplicateName')}`)
      }
    }
  }

  private async connect(): Promise<void> {
    this.vueForm.validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }
      const res: ConnectionModel | null = await updateConnection(this.connection.id as string, this.connection)
      if (res) {
        this.$emit('handleConnect', this.connection)
      }
    })
  }

  private disconnect() {
    this.vueForm.validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }
      this.$emit('handleDisconnect', this.connection)
    })
  }

  private cancel() {
    this.$emit('handleCancel', this.connection)
  }

  private refreshClientId() {
    this.connection.clientId = getClientId()
  }
}
